<!-- 联系我们 -->
<template>

    <div class="joinbox">
        <Header ></Header>
        <div class="banxin">
           <ul class="txtss">
               <li>
                   <p class="title">联系方式</p>
                   <p class="txt">联系地址：广州市天河区天河科技园</p>
                     <p class="txt">联系电话：020-89810547<br>（周一至周五，10:00-18:00）</p>
                     <!-- <p class="txt">客服QQ：800181050 </p> -->
                   <p></p>
               </li>
               <li>
                   <p class="title">微信公众号</p>
                   <p class="txt">微信公众号：nnzb689</p>
                    <p></p>
               </li>
               <li>
                   <p class="title">联系邮箱</p>
                       <p class="txt">合作&意见：kefu@gzxinyuzhou.com</p>
               </li>
               <li>
                   <p class="title">商务合作</p>
                   <p class="txt">公会进驻：nnzb_jiazu</p>
                   <p class="txt">家族进驻：nnzb_gonghui</p>
                   <p class="txt">主播进驻：nnzb_cat</p>
               </li>
          </ul>  
          <p class="title">客服帮助</p>
          <p class="txt">
              为及时解决您的问题，建议您通过客户端提交意见反馈，我们会尽快在24小时内受理您的问题<br><br>
               1.客服帮助：解封相关事宜或软件使用问题请关注微信公众号“nnzb689”联系在线客服咨询 <br>
               2.大额充值：请联系微信：nnzb_tu <br>
          </p>
        </div>
         <Footer></Footer>
    </div>  
</template>
<script>
import Header from "../../components/header"
import Footer from "../../components/footer"
export default {
     components: {
            Header,Footer
        },
    data(){
        return{

        }
    },
     created(){

    },
    methods:{

    },
}
</script>
<style lang="less" scoped>
  .joinbox{
       background:rgba(250,250,250,1);
  }

  .banxin{
      border-radius:.1rem;background:rgba(255,255,255,1);
       padding:0 .28rem; margin-top: .4rem;height: 3.5rem;
       .txtss{
           display: flex;height: 1.87rem;
           padding-top: .56rem; box-sizing: border-box;
           border-bottom: 1px solid #E6E6E6; margin-bottom: .3rem;
        li{
            width: 23%; 
        
        }
       }
           .title{
    font-size:0.12rem;  font-weight:600;
    color:rgba(51,51,51,1); margin-bottom: .22rem;
    } 
    .txt{
        font-size:0.08rem;  line-height: .12rem;
        color:rgba(51,51,51,1); margin-bottom: .12rem;
        } 
  }
</style>


// WEBPACK FOOTER //
// src/page/webpage/contactus.vue